module.exports = __webpack_public_path__ + "static/media/col1row2.ea66207a.jpg";